<div [@routerTransition]>
  <app-page-header [heading]="'Institution Details'" [icon]="'fa-hospital-o'"></app-page-header>
  <div *ngIf="user_rights.ADD == '1'" class="page-panel">
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class="row col-lg-12">
      <div class="form-group col-lg-4">
        <label>Name</label>
        <input [(ngModel)]="institution_data.institution_name" class="form-control "
               name="institution_name"
               type="text">
      </div>
      <div class="form-group col-lg-4">
        <label>Address</label>
        <textarea [(ngModel)]="institution_data.institution_address" class="form-control "
                  name="institution_address"
                  type="text"></textarea>
      </div>
      <div class="form-group col-lg-4">
        <label>Phone</label>
        <input [(ngModel)]="institution_data.institution_phone" class="form-control "
               name="institution_phone"
               type="text">
      </div>
      <div class="form-group col-lg-4">
        <label>State</label>
        <ngx-select-dropdown (change)="getcountry()" [(ngModel)]="country_data"
                             [config]="utils.dropConfig({displayKey: 'STATE_NAME',placeholder: 'Select State',searchOnKey: 'STATE_NAME'})"
                             [multiple]="false"
                             [options]="country_options" class="form-control  size"
                             name="country"></ngx-select-dropdown>
      </div>
      <div class="form-group col-lg-4">
        <label>VAT No</label>
        <input [(ngModel)]="institution_data.vat_no" class="form-control " name="vat_no" type="text">
      </div>
      <div class="form-group col-lg-4">
        <label>City</label>
        <input [(ngModel)]="institution_data.institution_city" class="form-control "
               name="institution_city"
               type="text">
      </div>
      <div class="form-group col-lg-4">
        <label>Email</label>
        <input [(ngModel)]="institution_data.institution_email" class="form-control "
               name="institution_email"
               type="text">
      </div>
      <div class="form-group col-lg-4">
        <label>Logo</label>
        <input #file
               (change)="getFileDetails($event)" accept=".png,.jpeg,.jpg" class="form-control "
               id="document" name="institution_logo"
               type="file">
        <div class="clearfix"></div>
        <div class="clearfix"></div>
        <div class="bordered ">
          <img alt="" height="50px" ngSrc="{{logo || image}}" width="100px">
        </div>
      </div>
    </div>
    <div class="row container">
      <div class="col-lg-7 pull-right">
        <button (click)=" saveInstitution()" *ngIf="user_rights.ADD == '1'" class="btn btn-sm btn-info " type="button">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>
